import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/home';
import HomeEn from '@/pages/home/en';
import About from '@/pages/about';
import AboutEn from '@/pages/about/en';
import About2 from '@/pages/about2';
import About3 from '@/pages/about3';
import About5 from '@/pages/about5';
import About6 from '@/pages/about6';
import About6En from '@/pages/about6/en';
import About8 from '@/pages/about8';
import Product from '@/pages/product';
/*import Service from '@/pages/Service';*/
import Service0 from '@/pages/Service0';
import Service0En from '@/pages/Service0/en';
import Service1 from '@/pages/Service1';
/*import Service2 from '@/pages/Service2';*/
import Service2En from '@/pages/Service2/en';
/*import Service3 from '@/pages/Service3';*/
import Service3En from '@/pages/Service3/en';
/*import Service4 from '@/pages/Service4';*/
import Service4En from '@/pages/Service4/en';
import Service5 from '@/pages/Service5';
import Service5En from '@/pages/Service5/en';
/*import Service6 from '@/pages/Service6';
import Service7 from '@/pages/Service7';*/
import Service7En from '@/pages/Service7/en';
/*import Service8 from '@/pages/Service8';*/
import Service8En from '@/pages/Service8/en';
/*import Service9 from '@/pages/Service9';*/
import Service9En from '@/pages/Service9/en';
/*import Service10 from '@/pages/Service10';*/
/*import Service101 from '@/pages/Service101';
import Service102 from '@/pages/Service102';
import Service103 from '@/pages/Service103';
import Service104 from '@/pages/Service104';
import Service105 from '@/pages/Service105';
import Service106 from '@/pages/Service106';
import Service107 from '@/pages/Service107';
import Service108 from '@/pages/Service108';
import Service109 from '@/pages/Service109';
import Service110 from '@/pages/Service110';*/
import Service10En from '@/pages/Service10/en';
import Service11 from '@/pages/Service11';
import Service11En from '@/pages/Service11/en';
import Service12 from '@/pages/Service12';
import Service12En from '@/pages/Service12/en';
import Service13 from '@/pages/Service13';
import Service13En from '@/pages/Service13/en';
import Service14 from '@/pages/Service14';
import Service14En from '@/pages/Service14/en';
import Service15 from '@/pages/Service15';
import Service15En from '@/pages/Service15/en';
import Service16 from '@/pages/Service16';
import Service16En from '@/pages/Service16/en';
import Health from '@/pages/health';
import Post from '@/pages/post';
import News from '@/pages/news';
import NewsEn from '@/pages/news/en';
import Notice from '@/pages/notice';
import NoticeEn from '@/pages/notice/en';
import Sciences from '@/pages/sciences';
import SciencesEn from '@/pages/sciences/en';
import Cooperations from '@/pages/cooperations';
import CooperationsEn from '@/pages/cooperations/en';
import Achievements from '@/pages/achievements';
import AchievementsEn from '@/pages/achievements/en';
import Achievements10 from '@/pages/achievements10';
import Achievements10En from '@/pages/achievements10/en';
import Plan from '@/pages/plan';
import Contact from '@/pages/contact';
import Imageset from '@/pages/imageset';
import ImagesetEn from '@/pages/imageset/en';
import Detail from '@/pages/detail';
import DetailEn from '@/pages/detail/en';
import Activity from '@/pages/activity';
import ActivityEn from '@/pages/activity/en';
import Event from '@/pages/event';
import HonorSystem from '@/pages/honor_system';
import Event1 from '@/pages/event1';
import Event1En from '@/pages/event1/en';
import Event2 from '@/pages/event2';
import Event2En from '@/pages/event2/en';
import Pts from '@/pages/pts';
import Zxs from '@/pages/zxs';
import Kyuser1 from '@/pages/kyuser1';
import Kyuser2 from '@/pages/kyuser2';
import Kyuser2En from '@/pages/kyuser2/en';
import Kyuser3 from '@/pages/kyuser3';
import Kyuser3En from '@/pages/kyuser3/en';
import Search from '@/pages/search';
import Tang from '@/pages/tang';
import Talent from '@/pages/talent';
import TalentDetail from '@/pages/talent/detail';
import Visitor from '@/pages/visitor';
import Yale from '@/pages/yale';
import Party from '@/pages/party';
import Party1 from '@/pages/party1';
import Party2 from '@/pages/party2';
import Rules from '@/pages/rules';
import ResearchService from '@/pages/research_service';

Vue.use(Router);
/* eslint-disable */
export default new Router({
  mode: 'history',
  routes: [{
      path: '/',//首页
      name: 'Home',
      component: Home
    },
    {
      path: '/en',//首页 en
      name: 'HomeEn',
      component: HomeEn
    },
    {
      path: '/about',//关于我们
      name: 'about',
      component: About
    },
    {
      path: '/about/en',//关于我们en
      name: 'aboutEn',
      component: AboutEn
    },
    {
      path: '/about2',//领导团队
      name: 'about2',
      component: About2
    },
    {
      path: '/about3',//技术系统
      name: 'about3',
      component: About3
    },
    {
      path: '/about5',//运行管理体系
      name: 'about5',
      component: About5
    },
    {
      path: '/about6',//运行管理体系
      name: 'about6',
      component: About6
    },
    {
      path: '/about8',//研究院简介
      name: 'about8',
      component: About8
    },
    {
      path: '/about6/en',//运行管理体系
      name: 'about6En',
      component: About6En
    },
    {
      path: '/product',//运行体系
      name: 'product',
      component: Product
    },
    {
      path: '/service0',//生物医学制造技术中心
      name: 'service0',
      component: Service0
    },
    {
      path: '/service0/en',//生物医学制造技术中心 en
      name: 'service0En',
      component: Service0En
    },
    // {
    //   path: '/service',//新药创制技术中心
    //   name: 'service',
    //   component: Service
    // },
    {
      path: '/service1',//公共仪器平台
      name: 'service1',
      component: Service1
    },
    // {
    //   path: '/service2',//生物医学数据科学中心
    //   name: 'service2',
    //   component: Service2
    // },
    {
      path: '/service2/en',//生物医学数据科学中心 en
      name: 'service2En',
      component: Service2En
    },
    // {
    //   path: '/service3',//模式动物技术中心
    //   name: 'service3',
    //   component: Service3
    // },
    {
      path: '/service3/en',//Center for Pharmaceutical Innovation
      name: 'service3En',
      component: Service3En
    },
    // {
    //   path: '/service4',//生物医学影像技术中心
    //   name: 'service4',
    //   component: Service4
    // },
    {
      path: '/service4/en',//Biomedical Imaging Center
      name: 'service4En',
      component: Service4En
    },
    {
      path: '/service5',//技术服务
      name: 'service5',
      component: Service5
    },
    {
      path: '/service5/en',//Model Animal Center
      name: 'service5En',
      component: Service5En
    },
    // {
    //   path: '/service6',//光谱波谱质谱平台
    //   name: 'service6',
    //   component: Service6
    // },
    // {
    //   path: '/service7',//新药研发与工艺安全性评价平台
    //   name: 'service7',
    //   component: Service7
    // },
    {
      path: '/service7/en',//Biotherapy Development Core
      name: 'service7En',
      component: Service7En
    },
    // {
    //   path: '/service8',//电镜 - 影像中心(平台)
    //   name: 'service8',
    //   component: Service8
    // },
    {
      path: '/service8/en',//Drug Screening Core
      name: 'service8En',
      component: Service8En
    },
    // {
    //   path: '/service9',//上海交通大学校级计算平台
    //   name: 'service9',
    //   component: Service9
    // },
    {
      path: '/service9/en',//上海交通大学校级计算平台 en
      name: 'service9En',
      component: Service9En
    },
    // {
    //   path: '/service10',//诊疗仪器开发平台
    //   name: 'service10',
    //   component: Service10
    // },
    {
      path: '/service10/en',//诊疗仪器开发平台 en
      name: 'service10En',
      component: Service10En
    },
    {
      path: '/service11',//共享实验室
      name: 'service11',
      component: Service11
    },
    {
      path: '/service11/en',//共享实验室 en
      name: 'service11En',
      component: Service11En
    },
    {
      path: '/service12',//
      name: 'service12',
      component: Service12
    },
    {
      path: '/service12/en',//Biomarker and Drug R&D Platform
      name: 'service12En',
      component: Service12En
    },
    {
      path: '/service13',//临床验证技术中心
      name: 'service13',
      component: Service13
    },
    {
      path: '/service13/en',//Electron Microscopy & Imaging Unit
      name: 'service13En',
      component: Service13En
    },
    {
      path: '/service14',//
      name: 'service14',
      component: Service14
    },
    {
      path: '/service14/en',//Surface & Properties Analysis Unit
      name: 'service14En',
      component: Service14En
    },
    {
      path: '/service15',//
      name: 'service15',
      component: Service15
    },
    {
      path: '/service15/en',//The Element Analysis Unit
      name: 'service15En',
      component: Service15En
    },
    {
      path: '/service16',//电镜 - 影像中心
      name: 'service16',
      component: Service16
    },
    {
      path: '/service16/en',//Spectrometry & Spectroscopy Unit
      name: 'service16En',
      component: Service16En
    },
    /*{
      path: '/service101',//诊疗装备开发服务平台
      name: 'service101',
      component: Service101
    },
    {
      path: '/service102',//上海交通大学校级计算平台
      name: 'service102',
      component: Service102
    },
    {
      path: '/service103',//高通量药物筛选平台
      name: 'service103',
      component: Service103
    },
    {
      path: '/service104',//高通量测序平台
      name: 'service104',
      component: Service104
    },
    {
      path: '/service105',//质谱检测平台
      name: 'service105',
      component: Service105
    },
    {
      path: '/service106',//生物治疗研发平台
      name: 'service106',
      component: Service106
    },
    {
      path: '/service107',//生信大数据平台
      name: 'service107',
      component: Service107
    },
    {
      path: '/service108',//创新医疗器械注册研究及临床转化服务中心
      name: 'service108',
      component: Service108
    },
    {
      path: '/service109',//运动转化医学中心
      name: 'service109',
      component: Service109
    },
    {
      path: '/service110',//代谢病组学解析技术中心
      name: 'service110',
      component: Service110
    },*/

    {
      path: '/health',//大健康
      name: 'health',
      component: Health
    },
    {
      path: '/post',//合作交流
      name: 'post',
      component: Post,
      children: [
      ]
    },
    {
      path: '/news',// 新闻
      name: 'news',
      component: News,
      children: [
        {
          path: 'news-1',// 访问学者
          name: 'news/:id',
          component: News,
        }
      ]
    },
    {
      path: '/news/en',// 新闻 en
      name: 'newsEn',
      component: NewsEn,
    },
    {
      path: '/notice',//公告
      name: 'notice',
      component: Notice
    },
    {
      path: '/notice/en',//公告 en
      name: 'noticeEn',
      component: NoticeEn
    },
    {
      path: '/sciences',//k科学普及
      name: 'sciences',
      component: Sciences
    },
    {
      path: '/sciences/en',//k科学普及 en
      name: 'sciencesEn',
      component: SciencesEn
    },
    {
      path: '/cooperations',//公告
      name: 'cooperations',
      component: Cooperations
    },
    {
      path: '/cooperations/en',// 科研合作
      name: 'cooperationsEn',
      component: CooperationsEn
    },
    {
      path: '/achievements',// 科研成果
      name: 'achievements',
      component: Achievements
    },
    {
      path: '/achievements/en',// 科研成果 en
      name: 'achievementsEn',
      component: AchievementsEn
    },
    {
      path: '/achievements10',// 10年 科研成果
      name: 'achievements10',
      component: Achievements10
    },
    {
      path: '/achievements10/en',// 10年 科研成果 en
      name: 'achievements10En',
      component: Achievements10En
    },
    {
      path: '/plan',//转化医学研究计划
      name: 'plan',
      component: Plan
    },
    {
      path: '/contact',//联系我们
      name: 'contact',
      component: Contact
    },
    {
      path: '/imageset',//合作伙伴
      name: 'imageset',
      component:Imageset
    },
    {
      path: '/imageset/en',//合作伙伴 en
      name: 'imagesetEn',
      component:ImagesetEn
    },
    {
      path: '/detail',//详情页
      name: 'detail',
      component:Detail
    },
    {
      path: '/detail/en',//详情页 en
      name: 'detailEn',
      component:DetailEn
    },
    {
      path: '/activity',//联合研究中心
      name: 'activity',
      component:Activity
    },
    {
      path: '/activity/en',//联合研究中心 en
      name: 'activityEn',
      component:ActivityEn
    },
    {
      path: '/event',//文件学习
      name: 'event',
      component:Event
    },
    {
      path: '/honor_system',//文件学习
      name: 'honor_system',
      component:HonorSystem
    },
    {
      path: '/event1',//star 星 计划
      name: 'event1',
      component:Event1
    },
    {
      path: '/event1/en',//star 星 计划 en
      name: 'event1En',
      component:Event1En
    },
    {
      path: '/event2',//自主研就
      name: 'event2',
      component:Event2
    },
    {
      path: '/event2/en',//自主研就 en
      name: 'event2En',
      component:Event2En
    },
    {
      path: '/pts',//平台
      name: 'pts',
      component:Pts
    },
    {
      path: '/zxs',// 中心
      name: 'zxs',
      component:Zxs
    },
    {
      path: '/kyuser1',//用户入驻
      name: 'kyuser1',
      component:Kyuser1
    },
    {
      path: '/kyuser2',//用户工作站
      name: 'kyuser2',
      component:Kyuser2
    },
    {
      path: '/kyuser2/en',//用户工作站 en
      name: 'kyuser2En',
      component:Kyuser2En
    },
    {
      path: '/kyuser3',//在站科研用户
      name: 'kyuser3',
      component:Kyuser3
    },
    {
      path: '/kyuser3/en',//在站科研用户 en
      name: 'kyuser3En',
      component:Kyuser3En
    },
    {
      path: '/search',// 搜索列表
      name: 'search',
      component:Search
    },
    {
      path: '/tang',// 唐仲英
      name: 'tang',
      component:Tang
    },
    {
      path: '/talent',// 人才队伍
      name: 'talent',
      component:Talent
    },
    {
      path: '/talent/detail',// 人才队伍 详情页
      name: 'talentDetail',
      component:TalentDetail
    },
    {
      path: '/Visitor',// 访问学者
      name: 'Visitor',
      component:Visitor
    },
    {
      path: '/yale',// 耶鲁中心
      name: 'yale',
      component:Yale
    },
    {
      path: '/party',// 访问学者
      name: 'party',
      component:Party
    },
    {
      path: '/party1',// 访问学者
      name: 'party1',
      component:Party1
    },
    {
      path: '/party2',// 访问学者
      name: 'party2',
      component:Party2
    },
    {
      path: '/rules',// 规章制度
      name: 'rules',
      component:Rules
    },
    {
      path: '/research_service',// 科研服务
      name: 'research_service',
      component:ResearchService
    }

  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js